import React from 'react';
import styled from 'styled-components';

interface MessageWithLinkProps {
  message: string;
  isVisible: boolean;
}

const MessageCard = styled.div`
  background: #FFFFFF;
  border: 1px solid #CBD5E1;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 4px 12px -4px rgba(15, 23, 42, 0.12);
  margin-bottom: 1rem;
  box-sizing: border-box;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px -6px rgba(139, 92, 246, 0.2);
    border-color: #8B5CF6;
  }
`;

const MessageText = styled.p`
  color: #475569;
  font-size: 1rem;
  font-family: 'Inter', system-ui, sans-serif;
  line-height: 1.5;
  margin-bottom: 1rem;
`;

// const MessageLink = styled.a`
//   color: #5c6bc0; // A more vibrant color for the link
//   text-decoration: none;
//   font-weight: 600; // Slightly bolder than before
//   padding: 0.25rem 0; // Padding for a larger clickable area
//   border-bottom: 2px solid transparent; // Invisible border for a smooth transition

//   &:hover {
//     border-bottom: 2px solid #5c6bc0; // Underline effect on hover
//   }
// `;

const AnimatedMessageCard = styled(MessageCard)<{ isVisible: boolean }>`
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transform: translateY(${props => (props.isVisible ? '0' : '20px')}) scale(${props => (props.isVisible ? 1 : 0.95)});
  transition: opacity 0.5s ease-out, transform 0.5s ease-out;
  pointer-events: ${props => (props.isVisible ? 'all' : 'none')};
  position: absolute;
  bottom: 100%;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 400px;
`;

const MessageWithLink: React.FC<MessageWithLinkProps> = ({ message, isVisible }) => {
  return (
    <AnimatedMessageCard isVisible={isVisible}>
      <MessageText>{message}</MessageText>
    </AnimatedMessageCard>
  );
};

export default MessageWithLink;
